// Other contexts factories
import UserServicesFactory from '../../user/Services/factory.js'
// Notifications factories
import NotificationsRepositoriesFactory from '../Repositories/factory.js'
import NotificationsValueObjectFactory from '../ValueObjects/factory.js'
// Notifications services
import GetPendingPtaCookieService from './GetPendingPtaCookieService.js'
import GetPendingPtaHttpService from './GetPendingPtaHttpService.js'
import {GetPendingPtaService} from './GetPendingPtaService.js'
import GetPendingPtaZeroValueService from './GetPendingPtaZeroValueService.js'
import SendEmailNotificationsService from './SendEmailValidationService.js'

export default class NotificationsServicesFactory {
  static getPendingPtaCookieService = ({config}) =>
    new GetPendingPtaCookieService({
      repository:
        typeof document !== 'undefined'
          ? NotificationsRepositoriesFactory.cookieNotificationsRepository({
              config
            })
          : NotificationsRepositoriesFactory.emptyNotificationsRepository({
              config
            })
    })

  static getPendingPtaHttpService = ({config}) =>
    new GetPendingPtaHttpService({
      repository: NotificationsRepositoriesFactory.httpNotificationsRepository({
        config
      })
    })

  static getPendingPtaService = ({config}) =>
    new GetPendingPtaService({
      cookieService: NotificationsServicesFactory.getPendingPtaCookieService({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      httpService: NotificationsServicesFactory.getPendingPtaHttpService({
        config
      }),
      zeroValueService: NotificationsServicesFactory.getPendingPtaZeroValueService()
    })

  static getPendingPtaZeroValueService = () =>
    new GetPendingPtaZeroValueService({
      pendingPtaVOFactory: NotificationsValueObjectFactory.pendingPtaValueObject
    })

  static sendEmailNotificationsService = ({config}) =>
    new SendEmailNotificationsService({
      httpRepository: NotificationsRepositoriesFactory.httpNotificationsRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      })
    })
}
